module.exports = __webpack_public_path__ + "img/pin-diamante-azul.6a631c15.png";